import { get } from '@/base/http-base.js'

export function getPolicyDetailById(id) {
  return get('/newscenter-api/v1/form/pc/news/detail', { id })
}
